module.exports = __webpack_public_path__ + "static/img/ba1.5d59a726.png";